import React, { useRef, useState } from "react";

const Section7 = ({ imgWebp, imgJpg, videoSrc, imgAlt, title, subtitle, desc }) => {
  const sliderRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  // Start dragging
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - sliderRef.current.offsetLeft);
    setScrollLeft(sliderRef.current.scrollLeft);
  };

  // While dragging
  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const x = e.pageX - sliderRef.current.offsetLeft;
    const walk = (x - startX) * 2; // Adjust speed
    sliderRef.current.scrollLeft = scrollLeft - walk;
  };

  // Stop dragging
  const handleMouseUp = () => {
    setIsDragging(false);
  };

  return (
    <section className="section-7">
      <div className="container">
        <div className="other-row content mb-5">
          <div className="col col-100">
            <h3 className="title">Customer Testimonials</h3>
            <p className="desc">Our water quality has never been better!</p>
          </div>
        </div>
        <div className="testimonial-container">
          <div 
            ref={sliderRef}
            className="testimonial-slider"
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
          >
            <div className="col col-33">
              <div className="stars">★★★★★</div>
              <div className="testimony">
                <h5>"From start to finish Mitch was easy to deal with. Not only was he professional but also provided reasonable pricing!!!!"</h5>
              </div>
              <div className="customer">
                <h6 className="name">Marcus Saguiguit</h6>
                <h6 className="position">Verified Customer</h6>
              </div>
            </div>
            <div className="col col-33">
              <div className="stars">★★★★★</div>
              <div className="testimony">
                <h5>"Excellent service and fairly priced. Mitch was polite and knowledgeable, helping me to sort out a few issues quickly. I highly recommend him to anyone."</h5>
              </div>
              <div className="customer">
                <h6 className="name">Subie Shop</h6>
                <h6 className="position">Verified Customer</h6>
              </div>
            </div>
            <div className="col col-33">
              <div className="stars">★★★★★</div>
              <div className="testimony">
                <h5>"Great service, very prompt and did an awesome job."</h5>
              </div>
              <div className="customer">
                <h6 className="name">Joe Pullos</h6>
                <h6 className="position">Verified Customer</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section7;